import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import { useDrag } from 'react-dnd';

import Droppable from './Droppable';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  tag: PropTypes.string,
  data: PropTypes.any,
  onMove: PropTypes.func,
  origin: PropTypes.string,
  node: PropTypes.any,
};

export function DroppableArea({ origin, onMove, node, type }) {
  const [isOver, setIsOver] = useState(false);

  const handleShowDroppable = useCallback(value => setIsOver(value), []);

  const slotStyle = {
    height: '100%',
    width: '100%',
    border: 'none',
  }

  if (origin === "active") {
    return <Droppable onMove={onMove} node={node} className={`${origin}`} type={type} />
  }

  if (origin === "slot") {
    return <div style={{ width: "100%", position: "relative", height: "1rem", zIndex: 1, marginBottom: '-0.50rem' }}>
      <Droppable tag="div" type="slot-item" origin="slot" onMove={onMove} node={node} style={slotStyle} onShowDroppable={handleShowDroppable}>
        <Droppable tag="div" type="page-item" origin="slot" onMove={onMove} node={node} style={{ ...slotStyle, paddingTop: '0.25rem' }} onShowDroppable={handleShowDroppable}>
          <div style={{ width: '100%', height: '2px', backgroundColor: isOver ? '#78CFE7 ' : 'transparent' }} />
        </Droppable>
      </Droppable>
    </div>
  }

  return null
}

function Draggable({ children, tag: Component, data, node, onMove, origin, type, ...props }) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type,
    item: { data, node },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  }))

  const style = isDragging ? { opacity: 0.8 } : {}

  return <>
    <DroppableArea origin={origin} onMove={onMove} node={node} type={type} />
    <Component {...props} style={{ cursor: 'move', ...style }} ref={drag}>
      {children}
    </Component>
  </>
}

Draggable.propTypes = propTypes;
Draggable.defaultProps = {
  tag: 'div',
};

export default Draggable;
